import authCheckApp from './authCheckApp'

/**
 * 打电话
 * 客户端检测tel字段必传，如果为空或者非法返回错误
 * @since 1.0.0
 * @param {Object} obj - 发送的消息
 * @param {string} obj.tel 电话号码
 * @returns {string} 返回状态
 * @example
 * 
 * makePhoneCall({
 *   "tel":"15082052758"
 * })
 */
function makePhoneCall(obj) {
    return new Promise((resolve, reject) => {
        authCheckApp()
            .then(() => {
                // 发起请求
                window.WebViewJavascriptBridge.callHandler('makePhoneCall', {
                    'tel': obj.tel
                }, (response) => {
                    if (typeof response === 'string') {
                        response = JSON.parse(response)
                    }
                    // 返回状态值为0成功
                    if (response.status === 0) {
                        resolve(response)
                    } else {
                        reject(response)
                    }
                })
            }).catch(err => {
                reject(err)
            })
    })
}

export default makePhoneCall